import _ from 'lodash';
import { getFormInitialValues } from 'redux-form';

export const isNameFieldDisabled = (state, formField) => {
    const initialValues = getFormInitialValues('ppcreditapply')(state);
    const fieldValue = _.get(initialValues, formField, '');
    const userLoggedIn = _.get(state, 'serverData.userLoggedIn');
    const isMemberFlow = _.get(state, 'serverData.isMemberFlow');
    const isDisabled = (userLoggedIn || isMemberFlow) && fieldValue.trim() !== '';
    const isSoftDisabled = userLoggedIn && _.get(state, 'serverData.showValidationSoftDecline');
    return !!isDisabled || !!isSoftDisabled;
};
